import { useEffect } from 'react'
import { BackHandler } from 'react-native'
import { User } from 'app/types'
import { useMuteUsername } from './commands'
import { ConfirmationModal, useToastController, ConfirmationModalOption } from '@my/ui'
import { getMutedUserQuery, groupPostCommentsQuery } from '../../queries'
import { userFeedQuery } from '../../screens/groups-feed-screen/queries'

export interface MuteUsernameModalContainerProps {
  groupPostId?: string
  mutee: Pick<User, 'id'>
  open: boolean
  onOpenChange: (open: boolean) => void
}

export const MuteUsernameModalContainer = (props: MuteUsernameModalContainerProps) => {
  const [muteUsername, { loading }] = useMuteUsername()
  const toast = useToastController()

  useEffect(() => {
    const backAction = () => {
      props.onOpenChange(false);
      return props.open
    }

    const backHandler = BackHandler.addEventListener(
      "hardwareBackPress",
      backAction
    );

    return () => backHandler.remove();
  }, [])

  const handleSubmit = async () => {
    try {
      await muteUsername({
        variables: {
          muteeId: props.mutee.id,
        },
        onCompleted: async (data) => {
          if (!data?.muteUser?.success) {
            throw new Error(data?.muteUser?.message || 'Failed to mute username')
          }
          toast.show('Username muted successfully')
        },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: getMutedUserQuery,
            variables: {
              muteeId: props.mutee.id,
            },
          },
          {
            query: userFeedQuery.query,
            variables: {
              ...userFeedQuery.defaultVariables,
            },
          },
          {
            ...(props?.groupPostId && {
              query: groupPostCommentsQuery.query,
              variables: {
                id: props.groupPostId,
                page: 1,
                limit: 20,
              },
            }),
          } as any,
        ].filter(Boolean),
      })
    } catch (error) {
      toast.show('Failed to mute username', {
        burntOptions: { preset: 'error' },
      })
      console.log(error)
    }
    props.onOpenChange(false)
  }

  const options: ConfirmationModalOption[] = [
    {
      children: 'Yes, Save',
      theme: 'black',
      onPress: handleSubmit,
      loading: loading,
    },
    {
      children: 'No, Cancel',
      plain: true,
      onPress: () => props.onOpenChange(false),
    },
  ]

  return (
    <ConfirmationModal
      title="Are you sure you want to mute this user?"
      open={props.open}
      onOpenChange={props.onOpenChange}
      onSubmit={handleSubmit}
      options={options}
    />
  )
}
